(() => {
  document.querySelectorAll('[data-grada-directory][data-directory-mode="clubs"]').forEach((directory) => {
    const heading = directory.querySelector('[data-directory-heading]');
    const viewAll = directory.querySelector('[data-directory-view-all]');
    const teams = [...directory.querySelectorAll('[data-directory-team]')];
    const empty = directory.querySelector('[data-directory-empty]');
    const grid = directory.querySelector('.grada-directory__grid');
    const featuredOrder = ['fc-barcelona', 'real-madrid'];
    if (grid) {
      [...teams]
        .sort((a, b) => {
          const aPriority = featuredOrder.indexOf(a.dataset.directoryName);
          const bPriority = featuredOrder.indexOf(b.dataset.directoryName);
          if (aPriority === -1 && bPriority === -1) return 0;
          if (aPriority === -1) return 1;
          if (bPriority === -1) return -1;
          return aPriority - bPriority;
        })
        .forEach((team) => grid.appendChild(team));
    }
    directory.querySelectorAll('[data-directory-choice]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const league = button.dataset.directoryChoice;
        let visible = 0;
        directory.querySelectorAll('[data-directory-choice]').forEach((choice) => {
          const active = choice === button;
          choice.classList.toggle('is-active', active);
          choice.setAttribute('aria-pressed', String(active));
          if (active) {
            choice.setAttribute('aria-current', 'true');
          } else {
            choice.removeAttribute('aria-current');
          }
        });
        teams.forEach((team) => {
          const match = team.dataset.directoryLeague === league;
          team.hidden = !match;
          if (match) visible += 1;
        });
        const leagueName = button.querySelector('span:nth-child(2)')?.textContent?.trim() || 'Equipos';
        if (heading) heading.textContent = leagueName;
        if (viewAll) {
          viewAll.href = button.dataset.directoryUrl;
          viewAll.firstChild.textContent = `Ver camisetas de ${leagueName} `;
        }
        if (empty) empty.hidden = visible > 0;
      });
    });
  });
})();
